import { Box, Button, Grid, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";

const pages = [
  {
    title: '基础链接',
    items: [
      { name: '主页', url: '/pages/home/home' },
      // { name: '商城', url: '/pages/store/store' },
      { name: '门店', url: '/pages/store-list/store-list' },
      { name: '订单', url: '/pages/payment-list/payment-list' },
      { name: '个人中心', url: '/pages/my/my' },
      { name: '商品分类', url: '/pages/product-category/product-category' },
      // { name: '商家入驻', url: 'MerchantApply' },
      { name: '会员之家', url: '/pages/vip-center/vip-center' },
    ]
  }
]


function CommonPages({ onSelect }) {

  function renderPages() {
    return pages.map(page => {
      const { title, items } = page;

      return (
        <Stack spacing={2} key={title}>
          <Typography variant="h6">{title}</Typography>
          <Grid container>
            {items.map(item => (
              <Grid item key={item.name} xs={2}>
                <Button onClick={() => onSelect(item.url)}>{item.name}</Button>
              </Grid>
            ))}
          </Grid>

        </Stack>
      )
    })
  }


  return (
    <Box>
      {renderPages()}
    </Box>
  );
}


export default CommonPages;
